import React, { useEffect, useState } from 'react';
import './ScrollToTop.css'; // Import your CSS file
import '@fortawesome/fontawesome-free/css/all.min.css'; // Correct Font Awesome import

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 200) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    isVisible && (
      <button className="scroll-to-top" onClick={scrollToTop}>
        <i className="fas fa-arrow-up" aria-hidden="true"></i> {/* Use Font Awesome arrow icon */}
      </button>
    )
  );
};

export default ScrollToTop;
